import "./additionalPages.css";
import Header from "../header/HeaderNavbar";
import Footer from "../footer/Footer";
import ScrollUp from "../scroll up/ScrollUpBtn";

export default function PrivacyPolicy({ windowWidth }) {
  return (
    <>
      <Header windowWidth={windowWidth}/>
      {windowWidth > 1200 && <ScrollUp />}
      <div className="mainText col">
        <h1>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
        <hr />
        <p>
          Настоящая Политика конфиденциальности персональных данных (далее —
          Политика конфиденциальности) действует в отношении всей информации,
          которую ИП Артемьев Артём Сергеевич ИНН 210802556940 (далее —
          Компания), Сайт которого размещён в сети Интернет по адресу:
          www.lider-prava.ru (далее — Сайт), может получить о Пользователе во
          время использования Сайта, его сервисов, программ и продуктов.
          <br />
          <br />
          Использование Сайта означает безоговорочное согласие Пользователя с
          настоящей Политикой и указанными в ней условиями обработки его
          персональной информации; в случае несогласия с этими условиями
          Пользователь должен воздершаться от использования сервисов.
        </p>
        <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
        <p>
          1.1. В настоящей Политике конфиденциальности используются следующие
          понятия:
          <br />
          1.1.1. Персональные данные — любая информация, относящаяся к прямо или
          косвенно определенному или определяемому физическому лицу (субъекту
          персональных данных — Пользователь);
          <br />
          1.1.2. Пользователь (субъект персональных данных) – физическое лицо,
          имеющий доступ к Сайту, пользующийся его сервисами, программами и
          продуктами на основании настоящей Политики конфиденциальности и
          Соглашения об обработке персональных данных;
          <br />
          1.1.3. Администрация Сайта (оператор) — уполномоченные сотрудники на
          управления Сайтом, действующие от имени Компании, которые организуют и
          (или) осуществляет обработку персональных данных, а также определяет
          цели обработки персональных данных, состав персональных данных,
          подлежащих обработке, действия (операции), совершаемые с персональными
          данными;
          <br />
          1.1.4. Обработка персональных данных — любое действие (операция) или
          совокупность действий (операций), совершаемых с использованием средств
          автоматизации или без использования таких средств с персональными
          данными, включая сбор, запись, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), извлечение, использование, передачу
          (распространение, предоставление, доступ), обезличивание,
          блокирование, удаление, уничтожение персональных данных;
          <br />
          1.1.5. Конфиденциальность персональных данных — обязательное для
          соблюдения Оператором или иным получившим доступ к персональным данным
          лицом требование не допускать их распространения без согласия субъекта
          персональных данных или наличия иного законного основания;
          <br />
          1.1.6. Cookies — небольшой фрагмент данных, отправленный веб-сервером
          и хранимый на компьютере пользователя, который веб-клиент или
          веб-браузер каждый раз пересылает веб-серверу в HTTP(S)-запросе при
          попытке открыть страницу соответствующего сайта;
          <br />
          1.1.7. IP-адрес — уникальный сетевой адрес узла в компьютерной сети,
          построенной по протоколу IP.
          <br />
          1.2. Использование Пользователем Сайта означает согласие с настоящей
          Политикой конфиденциальности и условиями обработки персональных данных
          Пользователя.
          <br />
          1.3. В случае несогласия с условиями Политики конфиденциальности
          Пользователь должен прекратить использование Сайта.
          <br />
          1.4. Настоящая Политика конфиденциальности применяется только к Сайту,
          Компания не контролирует и не несет ответственность за сайты третьих
          лиц, на которые Пользователь может перейти по ссылкам, доступным на
          Сайте.
          <br />
          1.5. Администрация Сайта не проверяет достоверность персональных
          данных, предоставляемых Пользователем.
        </p>
        <h2>2. ПРЕДМЕТ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ</h2>
        <p>
          2.1. Настоящая Политика конфиденциальности устанавливает обязательства
          Администрации Сайта по неразглашению и обеспечению режима защиты
          конфиденциальности персональных данных, которые Пользователь
          предоставляет по запросу Администрации Сайта при регистрации на Сайте
          или при заключении договора для получения услуг.
          <br />
          2.2. Персональные данные, разрешённые к обработке в рамках настоящей
          Политики конфиденциальности, предоставляются Пользователем путём
          заполнения регистрационных форм на Сайте и включают в себя следующую
          информацию:
          <br />
          2.2.1. фамилию, имя, отчество Пользователя;
          <br />
          2.2.2. контактный телефон Пользователя;
          <br />
          2.2.3. адрес электронной почты (e-mail) Пользователя.
          <br />
          2.3. Компания защищает Данные, которые автоматически передаются в
          процессе просмотра рекламных блоков и при посещении страниц, на
          которых установлен статистический скрипт системы («пиксель»):
          <br />
          • IP-адрес;
          <br />
          • информация из cookies;
          <br />
          • информация о браузере (или иной программе, которая осуществляет
          доступ к показу рекламы);
          <br />
          • время доступа;
          <br />
          • адрес страницы, на которой расположен рекламный блок;
          <br />
          • реферер (адрес предыдущей страницы).
          <br />
          2.3. Отключение cookies может повлечь невозможность доступа к частям
          Сайта, требующим авторизации.
          <br />
          2.4. Компания осуществляет сбор статистики об IP-адресах своих
          Пользователей. Данная информация используется с целью выявления и
          решения технических проблем, для контроля законности проводимых
          финансовых платежей.
          <br />
          2.5. Любая иная персональная информация неоговоренная выше (история
          платежей, используемые браузеры и операционные системы и т.д.)
          подлежит надежному хранению и нераспространению, за исключением
          случаев, предусмотренных в п.п. 4.2. и 4.3. настоящей Политики
          конфиденциальности.
        </p>
        <h2>3. ЦЕЛИ СБОРА ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ</h2>
        <p>
          3.1. Персональные данные Пользователя, Администрация Сайта может
          использовать в целях:
          <br />
          3.1.1. Идентификации Пользователя, зарегистрированного на Сайте, для
          заключения договора с Компанией.
          <br />
          3.1.2. Предоставления Пользователю доступа к персонализированным
          ресурсам Сайта.
          <br />
          3.1.3. Установления с Пользователем обратной связи, включая
          направление уведомлений, запросов, касающихся использования Сайта,
          оказания услуг, обработка запросов и заявок от Пользователя.
          <br />
          3.1.4. Определения места нахождения Пользователя для обеспечения
          безопасности, предотвращения мошенничества.
          <br />
          3.1.5. Подтверждения достоверности и полноты персональных данных,
          предоставленных Пользователем.
          <br />
          3.1.6. Создания учетной записи для совершения платежей, если
          Пользователь дал согласие на создание учетной записи.
          <br />
          3.1.7. Обработки и получения платежей, подтверждения налога или
          налоговых льгот, оспаривания платежа, определения права на получение
          кредитной линии Пользователем.
          <br />
          3.1.8. Предоставления Пользователю эффективной клиентской и
          технической поддержки при возникновении проблем связанных с
          использованием Сайта.
          <br />
          3.1.9. Предоставления Пользователю с его согласия, обновлений услуг,
          специальных предложений, информации о ценах, новостной рассылки и иных
          сведений от имени Компании или от имени партнеров Компании.
          <br />
          3.1.10. Осуществления рекламной деятельности с согласия Пользователя.
          <br />
          3.1.11. Проведения аудита и прочих внутренних исследований с целью
          повышения качеств предоставляемых услуг.
        </p>
        <h2>4. СПОСОБЫ И СРОКИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ</h2>
        <p>
          4.1. Обработка персональных данных Пользователя осуществляется без
          ограничения срока, любым законным способом, в том числе в
          информационных системах персональных данных с использованием средств
          автоматизации или без использования таких средств.
          <br />
          4.2. Пользователь соглашается с тем, что Администрация Сайта вправе
          передавать персональные данные третьим лицам, в частности, курьерским
          службам, организациями почтовой связи, операторам электросвязи,
          исключительно в целях выполнения заключенных с Пользователем
          договоров.
          <br />
          4.3. Персональные данные Пользователя могут быть переданы
          уполномоченным органам государственной власти Российской Федерации
          только по основаниям и в порядке, установленным законодательством
          Российской Федерации.
          <br />
          4.4. При утрате или разглашении персональных данных Администрация
          Сайта информирует Пользователя об утрате или разглашении персональных
          данных.
          <br />
          4.5. Администрация сайта принимает необходимые организационные и
          технические меры для защиты персональной информации Пользователя от
          неправомерного или случайного доступа, уничтожения, изменения,
          блокирования, копирования, распространения, а также от иных
          неправомерных действий третьих лиц.
          <br />
          4.6. Администрация сайта совместно с Пользователем принимает все
          необходимые меры по предотвращению убытков или иных отрицательных
          последствий, вызванных утратой или разглашением персональных данных
          Пользователя.
        </p>
        <h2>5. ОБЯЗАТЕЛЬСТВА СТОРОН</h2>
        <p>
          5.1. Пользователь обязан:
          <br />
          5.1.1. Предоставить информацию о персональных данных, необходимую для
          пользования Сайтом.
          <br />
          5.1.2. Обновить, дополнить предоставленную информацию о персональных
          данных в случае изменения данной информации.
          <br />
          5.2. Администрация Сайта обязана:
          <br />
          5.2.1. Использовать полученную информацию исключительно для целей,
          указанных в п. 3 настоящей Политики конфиденциальности.
          <br />
          5.2.2. Обеспечить хранение конфиденциальной информации в тайне, не
          разглашать без предварительного письменного разрешения Пользователя, а
          также не осуществлять продажу, обмен, опубликование, либо разглашение
          иными возможными способами переданных персональных данных
          Пользователя, за исключением п.п. 4.2. и 4.3. настоящей Политики
          Конфиденциальности.
          <br />
          5.2.3. Принимать меры предосторожности для защиты конфиденциальности
          персональных данных Пользователя согласно порядку, обычно
          используемого для защиты такого рода информации в существующем деловом
          обороте.
          <br />
          5.2.4. Осуществить блокирование персональных данных, относящихся к
          соответствующему Пользователю, с момента обращения или запроса
          Пользователя или его законного представителя либо уполномоченного
          органа по защите прав субъектов персональных данных на период
          проверки, в случае выявления недостоверных персональных данных или
          неправомерных действий.
        </p>
        <h2>6. ОТВЕТСТВЕННОСТЬ СТОРОН</h2>
        <p>
          6.1. Администрация Сайта, не исполнившая свои обязательства, несёт
          ответственность за убытки, понесённые Пользователем в связи с
          неправомерным использованием персональных данных, в соответствии с
          законодательством Российской Федерации, за исключением случаев,
          предусмотренных п.п. 4.2., 4.3. и 6.2. настоящей Политики
          Конфиденциальности.
          <br />
          6.2. В случае утраты или разглашения Конфиденциальной информации
          Администрация Сайта не несёт ответственность, если данная
          конфиденциальная информация:
          <br />
          6.2.1. Стала публичным достоянием до её утраты или разглашения.
          <br />
          6.2.2. Была получена от третьей стороны до момента её получения
          Администрацией Сайта.
          <br />
          6.2.3. Была разглашена с согласия Пользователя.
        </p>
        <h2>7. РАЗРЕШЕНИЕ СПОРОВ</h2>
        <p>
          7.1. До обращения в суд с иском по спорам, возникающим из отношений
          между Пользователем и Администрацией Сайта, обязательным является
          предъявление претензии (письменного предложения о добровольном
          урегулировании спора).
          <br />
          7.2. Получатель претензии в течение 30 календарных дней со дня
          получения претензии, письменно уведомляет заявителя претензии о
          результатах рассмотрения претензии.
          <br />
          7.3. При не достижении соглашения спор будет передан на рассмотрение в
          судебный орган в соответствии с действующим законодательством
          Российской Федерации.
          <br />
          7.4. К настоящей Политике конфиденциальности и отношениям между
          Пользователем и Администрацией Сайта применяется действующее
          законодательство Российской Федерации.
        </p>
        <h2>8. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
        <p>
          8.1. Администрация Сайта вправе вносить изменения в настоящую Политику
          конфиденциальности без согласия Пользователя.
          <br />
          8.2. Новая Политика конфиденциальности вступает в силу с момента ее
          размещения на Сайте, если иное не предусмотрено новой редакцией
          Политики конфиденциальности.
          <br />
          8.3. Все предложения или вопросы по настоящей Политике
          конфиденциальности следует сообщать в администрацию сайта по адресу
          электронной почты liderprerava21@ya.ru
          <br />
          8.4. Правовым основанием обработки персональных данных является
          Соглашение об обработке персональных данных, а также договоры,
          заключаемые между Компанией и Пользователем.
        </p>
      </div>
      <Footer />
    </>
  );
}
